<script setup>
import { useNewsStore } from '@stores/news'

import ArticleCard from '@components/global/article-card.vue'
import Button from '@components/global/button.vue'

const news = useNewsStore()
</script>
<template>
	<section class="container flex flex-col gap-10" v-if="news.articles.length">
		<div class="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
			<div class="flex flex-col gap-4">
				<span class="h9">Blog</span>
				<h4 class="mt-2">Recent Articles</h4>
				<span class="font-semibold">Stay Updated with the Latest Insights.</span>
			</div>
			<Button :to="{ name: 'blog' }" label="Visit out blog" class="secondary" />
		</div>

		<div class="flex flex-col gap-6 lg:flex-row">
			<ArticleCard :item="news.articles.slice(0, 1)[0]" class="w-full lg:w-half" type="main" />
			<div class="flex w-full flex-col gap-6 lg:w-half">
				<ArticleCard v-for="item in news.articles.slice(1, 2)" :item="item" :key="item.title" />
			</div>
		</div>
	</section>
</template>
